// extracted by mini-css-extract-plugin
export default {"text":"text__889W1"};